<template>
    <div class="alert" v-if="message">
        <p>{{message}}<br><br>We apologize for the inconvenience</p>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      interval: null,
      currentMsgId: null,
      message: null
    }
  },
  created () {
    this.loadData()
    this.interval = setInterval(() => {
      this.loadData()
    }, 5000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = null
  },
  methods: {
    loadData () {
      axios.get(`https://gate01.se/api/alert/read_one.php`)
        .then(response => {
          if (response && response.data && response.data.id !== this.currentMsgId) {
            this.currentMsgId = response.data.id
            this.message = response.data.message
          } else if (response && response.data && response.data.id === this.currentMsgId) {
            // same item as we already have... ignore
          } else {
            this.message = null
          }
        }).catch(() => {
          this.message = null
        })
    }
  }
}
</script>

<style lang="scss">
  .alert {
        position: absolute;
        top: 25%;
        left: 10%;
        right: 10%;
        // width: 70%;
        z-index: 10;
        padding: 4rem;
        background: rgba(0, 0, 0, 0.5);
        p {
            font-size: 2.6rem;
            line-height: 4rem;
            + p {
                margin-top: 5rem;
            }
        }
    }
</style>
